import { combineReducers } from 'redux';

import { securityModuleReducer } from 'modules/security/moduleReducer';
import { commonReducer } from 'modules/common/commonReducer';
import { orderingModuleReducer } from 'modules/ordering/moduleReducer';
import { authModuleReducer } from 'modules/auth/moduleReducer';
import { kioskModuleReducer } from 'modules/kiosk/moduleReducer';
import { tvPanelModuleReducer } from 'modules/tvpanel/moduleReducer';
import { adiminModuleReducer } from 'modules/admin/moduleReducer';
import { directorModuleReducer } from 'modules/director/moduleReducer';
import { managerModuleReducer } from 'modules/manager/moduleReducer';

const rootReducer = combineReducers({
  securityModuleReducer,
  commonReducer,
  orderingModuleReducer,
  authModuleReducer,
  kioskModuleReducer,
  tvPanelModuleReducer,
  adiminModuleReducer,
  directorModuleReducer,
  managerModuleReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
